import { AvailableProperty, AxnAvailablePropertyCategory } from "@idw-types/data/reference-data/axn";

export const extractAvailablePropertiesFromCategories = (
    axnAvailablePropertyCategories: Array<AxnAvailablePropertyCategory>
): Array<AvailableProperty & { category: string }> => {
    const availableProperties: Array<AvailableProperty & { category: string }> = [];

    axnAvailablePropertyCategories.forEach(apc => {
        apc.availableProperty.forEach(ap => {
            availableProperties.push({
                ...ap,
                category: apc.name
            });
        });
    });

    return availableProperties;
};